class FortuneSavingRateSumGroupedByGroupName {
    name!: string;
    sum!:  number;    
}

export default FortuneSavingRateSumGroupedByGroupName;